import { Icon } from '@elements-financial/elements';
import { useTranslation } from 'react-i18next';

export function UpdatingAccountsNotification() {
  const { t: tHome } = useTranslation('home');

  return (
    <div className='fixed left-0 top-0 right-0 p-2 z-50'>
      <div className="rounded-[16px] p-5 shadow-mobileTile bg-[#212326]">
        <div className="flex items-center space-x-4 h-6">
          <div className="flex-1 text-[18px] font-normal tracking-[-0.18px] text-darkMode-gray-light">{tHome('updating-accounts')}</div>
          <Icon icon="spinner" className="w-5 h-5 text-palette-600" />
        </div>
      </div>
    </div>
  );
}